import { StatusPip, Tile, type StatusPipStatus } from '@diwata/ironvale'
import type { DocsFeed, DocsItem } from '@/api/feeds'
import { UnavailableNote } from './shared'

function itemPip(item: DocsItem): StatusPipStatus {
  if (item.error > 0) return 'red'
  if (item.warning > 0) return 'warn'
  return 'ok'
}

/** `grain docs audit` counts per workspace root. */
export function DocsTile({ feed }: { feed: DocsFeed }) {
  const items = feed.items ?? []
  const status: StatusPipStatus =
    feed.status === 'unavailable'
      ? 'unavailable'
      : items.some((i) => i.error > 0)
        ? 'red'
        : items.some((i) => i.warning > 0)
          ? 'warn'
          : 'ok'
  return (
    <Tile title="Docs" status={status} asOf={feed.asOf}>
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <div className="ap-tile-rows">
          {items.map((item) => (
            <div key={item.repo} className="ap-tile-row">
              <StatusPip status={itemPip(item)} label={`${item.repo} ${item.overall}`} />
              <span className="ap-row-name">{item.repo}</span>
              <span className="ap-row-meta ap-mono">
                {item.pass}✓ <span className="ap-warn-text">{item.warning}</span>{' '}
                <span className="ap-red-text">{item.error}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </Tile>
  )
}
